export default {
  namespaced: true,
  state: {
    items: []
  },
  getters: {
    getAll: state => state.items,
    /**
     * Préparateurs porteurs d'un droit donné (ex. 'renting_im-preparator').
     * L'API ne renvoie que des utilisateurs habilités sur au moins un des trois groupes :
     * le filtre sert à répartir la liste par groupe de préparation.
     */
    getByAuthorization: state => authorization => state.items.filter(
      item => item.authorization_list && item.authorization_list[authorization] == true
    )
  },
  actions: {
    /**
     * Charge les utilisateurs habilités à préparer, quel que soit leur rôle : le périmètre est
     * calculé côté API à partir des seules autorisations renting_{im,ot,snl}-preparator.
     *
     * Cette liste a son propre espace de nom, et non celui de `user` : les écrans d'affectation
     * n'ont pas à écraser l'annuaire chargé par les écrans utilisateurs, et inversement.
     * @param   {boolean} wait  Si wait = true, on attend les données avant le resolve()
     * @returns {promise}
     */
    getAll: (context, wait = false) => {
      let params = {
        wait: wait,
        api_url: 'user/index/preparators',
        api_data_path: 'users',
        namespace: 'renting_preparator'
      }
      return context.dispatch('getAll', params, {
        root: true
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/stores/modules/renting_preparator.js